import {connect} from "react-redux";
import Home from "./Home";
import {bindActionCreators} from "redux";
import {homePageContent, fetchReportee, lastTenDaysInactiveAccount, homeFilter} from "../../../service/Common/action";

const mapStateToProps = (state) => ({
    homePageDetails:state.Common.homePageDetails,
    reportee:state.Common.reportee,
    inactiveAccount:state.Common.inactiveAccount,
    filterDetails:state.Common.filterDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            homePageContent,
            fetchReportee,
            lastTenDaysInactiveAccount,
            homeFilter
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Home);
